import { withHookProps } from 'platform-components';
import { useMemo } from 'react';
import { subjectsOrderSort } from 'store/courses/utils';
import { useSelector } from 'react-redux';
import { getSubjectConfigList } from 'store/subject-config/selectors';
import { useIntl } from 'react-intl';
import { useSubjectGrades } from './queries';

export function useSubjectGradesProps() {
    const subjectGradesQuery = useSubjectGrades();
    const subjectConfig = useSelector(getSubjectConfigList);
    const intl = useIntl();

    const subjectGradesInfo = useMemo(() => {
        if (!subjectGradesQuery.data) {
            return [];
        }
        // удаляем предметы без грейдов и сортируем согласно данным из бункера "subjectConfig"
        const orderedSubjects = subjectsOrderSort(
            Object.entries(subjectGradesQuery.data)
                .filter(([_, subjectGrades]) => subjectGrades.length > 0)
                .map(([subjectKey]) => ({
                    subject: subjectKey,
                    name: intl.formatMessage({ id: `library.subjectName.${subjectKey}` }, { grade: 'other' }),
                })) || [],
            subjectConfig
        );

        return {
            orderedSubjects,
            isSuccess: subjectGradesQuery.isSuccess,
            subjectGrades: subjectGradesQuery.data,
        };
    }, [subjectGradesQuery, intl, subjectConfig]);

    return {
        subjectGradesInfo,
    };
}

export type SubjectGradesProps = {
    subjectGradesInfo?: ReturnType<typeof useSubjectGradesProps>['subjectGradesInfo'];
};

export const withSubjectGrades = withHookProps<object, object>(useSubjectGradesProps);
